/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ARENA_TOOLTIP_TITLE = [
    <FormattedMessage
        key='arena_tooltip.point.1'
        id='arena_tooltip.point.1'
        defaultMessage='Передовой рубеж'
    />,
    <FormattedMessage
        key='arena_tooltip.point.2'
        id='arena_tooltip.point.2'
        defaultMessage='Запасной рубеж'
    />,
    <FormattedMessage
        key='arena_tooltip.point.3'
        id='arena_tooltip.point.3'
        defaultMessage='Цитадель'
    />,
]

export const ARENA_TOOLTIP_DIRECTION = (direction) => {
    return (
        <FormattedMessage
            id='arena_tooltip.direction'
            defaultMessage='{direction} плацдарм'
            values={{ direction }}
        />
    )
}

export const ARENA_TOOLTIP_BATTLE_MAP = (map) => {
    return (
        <FormattedMessage
            id='arena_tooltip.battle_map'
            defaultMessage='Карта: {map}'
            values={{ map }}
        />
    )

}

export const ARENA_EXCLUDED = (
    <FormattedMessage
        id='journal.battles_history.arena_excluded'
        defaultMessage='Карта выведена из игры'
    />
)



// WEBPACK FOOTER //
// ./components/ArenaTooltip/constants.jsx